import { css } from '@linaria/atomic';

export const styles = {
  container: css`
    border: 1px solid var(--pfpb-border, var(--fabric-color-accent-seaweed-base));
    border-radius: var(--fabric-number-n-4-px);
    display: flex;
    flex-direction: column;
    box-shadow: var(--fabric-card-shadow);
    box-sizing: border-box;
    container-type: inline-size;
    position: relative;
    overflow: hidden;
    background-color: var(--fabric-color-surface-default);
    width: 100%;
  `,
  header: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--fabric-space-gap-xs);
    padding: var(--fabric-space-padding-sm) var(--fabric-space-padding-md);
    background-color: var(--pfpb-header-bg, var(--fabric-color-accent-seaweed-alpha-subtle));
  `,
  headerStart: css`
    display: flex;
    align-items: center;
    gap: var(--fabric-space-gap-xs);
    min-width: 0;
  `,
  headerLeading: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  `,
  headerTitle: css`
    line-height: 1.25;
    margin: 0;
    color: var(--fabric-color-text-primary);
  `,
  headerTrailing: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: auto;
  `,
  body: css`
    display: flex;
    flex-direction: column;
    padding: var(--fabric-space-padding-md);
    gap: var(--fabric-space-gap-md);
    background-color: var(--fabric-color-surface-default);
  `,
  title: css`
    line-height: 1.35;
    color: var(--fabric-color-text-primary);
  `,
  description: css`
    line-height: 1.4;
    color: var(--fabric-color-text-secondary);
  `,
  featureChips: css`
    display: flex;
    flex-wrap: wrap;
    gap: var(--fabric-space-gap-xs);
  `,
  featureChipsGrid: css`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--fabric-space-gap-xs);

    @container (max-width: 320px) {
      grid-template-columns: 1fr;
    }
  `,
  featureChip: css`
    background: var(--pfpb-chip-bg, var(--fabric-color-accent-seaweed-alpha-subtle));
    color: var(--fabric-color-text-primary);
    font-size: var(--fabric-font-size-sm, 13px);
    gap: var(--fabric-space-gap-xxs);

    .chip-text {
      font-weight: var(--fabric-font-weight-medium, 500);
    }
  `,
  featureChipIcon: css`
    color: var(--pfpb-icon, var(--fabric-color-accent-seaweed-base));
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  `,
  media: css`
    background-color: var(--fabric-color-surface-inset-default);
    border-radius: var(--fabric-radius-md);
    padding: var(--fabric-space-padding-md);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
  `,
  mediaNoBackground: css`
    background-color: transparent;
    padding: 0;
  `,
  highlights: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--fabric-space-gap-xs);
  `,
  highlightItem: css`
    display: inline-flex;
    align-items: center;
    gap: var(--fabric-space-gap-xxs);
  `,
  highlightIcon: css`
    color: var(--pfpb-icon, var(--fabric-color-accent-seaweed-base));
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  `,
  highlightText: css`
    color: var(--fabric-color-text-primary);
    font-size: var(--fabric-font-size-sm, 13px);
    line-height: 1.2;
  `,
  bullet: css`
    color: var(--fabric-color-text-subtle);
    font-weight: bold;
    user-select: none;
    margin: 0 var(--fabric-space-gap-xxs);
  `,
  actions: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--fabric-space-gap-sm);
    flex-wrap: wrap;

    @container (max-width: 375px) {
      flex-direction: column;
      align-items: stretch;
    }
  `,
  actionsPrimaryGroup: css`
    display: flex;
    align-items: center;
    gap: var(--fabric-space-gap-sm);
    flex-wrap: wrap;

    @container (max-width: 375px) {
      flex-direction: column;
      align-items: stretch;
      width: 100%;
    }
  `,
  actionsDismissGroup: css`
    display: flex;
    align-items: center;

    @container (max-width: 375px) {
      justify-content: center;
      width: 100%;
    }
  `,
  dismissButton: css`
    color: var(--fabric-color-text-secondary);

    &:hover {
      color: var(--fabric-color-text-primary);
    }
  `,
};
